import React from "react";
import { Outlet } from "react-router";
import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import Nav from "./Nav";

const Layout = (props) => {
  const { entryPage, userStatus, contestStatus } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Nav
        entryPage={entryPage}
        userStatus={userStatus}
        contestStatus={contestStatus}
      />

      <Outlet />

      {/* Spotlight footer */}
      <Grid
        container
        sx={{
          width: "100%",
          justifyContent: "center",
          padding: isMobile ? "24px 16px 80px" : "24px 32px 90px",
        }}
      >
        <Typography variant="body2" sx={{ color: theme.branding.gray[500] }}>
          Sponsored by{" "}
          <span style={{ color: theme.branding.cyan[300], fontWeight: 600 }}>
            SpotlightNews
          </span>
        </Typography>
      </Grid>
    </>
  );
};

export default Layout;
